import React from "react";
import "../../assets/styles/Footer/mission.css";
import "../../assets/styles/Footer/contactUs.css";
import "../../assets/styles/Footer/footerAbout.css";
import FooterNav from "../../Pages/auth/footerLogin/FooterNav";
import { Helmet } from "react-helmet";
import FootNav from "../../Pages/User_Profile/Footer/Footer-nav/FootNav";

const ChildSafety = () => {
  return (
    <div style={{ background: "white" }}> 
      <Helmet>
        <meta property="og:url" content="child-safety-standards.html" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Child Safety Standards" />
        <meta property="og:description" content="At iBouge, protecting children is a top priority" />
      </Helmet>
      <FooterNav from={"childsafety"}/>
      <div className="MainContact mb-5 p-0 border border-gray">
        <div className="Contactheading">
          <p>Child Safety Standards</p>
        </div>
        <div className="p-5 bg-white">

          <p>Developer: iBouge</p>

          <p className="mt-4">App: iBouge Social Network</p>

          <p className="mt-4 mb-4">At iBouge, we are committed to maintaining a safe environment for all users. Accordingly, we prohibit, and have a zero-tolerance policy when it comes to child sexual abuse and exploitation (CSAE). Any activity or content that promotes, involves, or depicts sexual exploitation of minors is strictly prohibited. This includes, but is not limited to, activities such as:</p>

          <ul>
            <li>Any form of grooming behavior</li>
            <li>Sexual conversations involving individuals under 18 </li>
            <li>Sharing or requesting sexual content involving minors</li>
            <li>Attempts to exploit or harm minors in any way</li>
          </ul>

          <p className="mt-5 mb-4">Reporting and Enforcement: Users can report inappropriate content or behavior directly within the app using the reporting feature. All reports are reviewed promptly, and appropriate actions are taken, including:</p>
          <ul>
            <li>Content removal </li>
            <li>Account suspension or termination </li>
            <li>Reporting to relevant authorities where required</li>
          </ul>

          <p className="mt-5">Child Safety Contact: If you have concerns related to child safety, you can contact us at: <a href="mailto:support@ibouge.com">support@ibouge.com</a> We comply with all applicable child safety laws and regulations.</p>

        </div>
      </div>
      <FootNav from={"Mission"}/>
    </div>
  );
};

export default ChildSafety;